var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39.5 30.4"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 183"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 233",
    d: "M33.5 0H16.4a5.831 5.831 0 0 0-4.6 2.2l-1.4 1.5L0 15.2l10.4 11.6 1.7 1.8a6.043 6.043 0 0 0 4.3 1.8h17.1a6.018 6.018 0 0 0 6-6V6a6.018 6.018 0 0 0-6-6Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 182",
    fill: "none",
    stroke: "#000",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 234",
    d: "m19.2 10.2 10.6 10.6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 235",
    d: "m19.2 20.8 10.6-10.6"
  })))));
};
export default SvgDelete;